import api from './api'

export interface Student {
  id: string
  firstName: string
  lastName: string
  classId: string
  class?: {
    id: string
    name: string
  }
  email?: string
  createdAt: string
  updatedAt: string
}

const studentService = {
  async getAll(): Promise<Student[]> {
    const response = await api.get('/api/students')
    return response.data
  },

  async getById(id: string): Promise<Student> {
    const response = await api.get(`/api/students/${id}`)
    return response.data
  },

  async getByClass(classId: string): Promise<Student[]> {
    const response = await api.get(`/api/students?classId=${classId}`)
    return response.data
  },

  async create(data: Partial<Student>): Promise<Student> {
    const response = await api.post('/api/students', data)
    return response.data
  },

  async update(id: string, data: Partial<Student>): Promise<Student> {
    const response = await api.put(`/api/students/${id}`, data)
    return response.data
  },

  async delete(id: string): Promise<void> {
    await api.delete(`/api/students/${id}`)
  }
}

export default studentService
